import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscribePopupComponent } from './subscribe-popup.component';
import { MaterialModule } from '../../material/material.module';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [SubscribePopupComponent],
  imports: [
    CommonModule,
    MaterialModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports:[
    SubscribePopupComponent
  ]
})
export class SubscribePopupModule {}
